import React from 'react';
import './PathwayScopeToggle.css';

/**
 * Radio-style filter: CTE concentrations vs Course-Subject rows.
 * @param {'concentration'|'course_subject'} value
 * @param {(v: 'concentration'|'course_subject') => void} onChange
 */
export default function PathwayScopeToggle({
  value,
  onChange,
  hasConcentrations = true,
  hasSubjects = true,
  compact = true,
  idPrefix = 'pathway-scope'
}) {
  return (
    <div
      className={`pathway-scope-toggle${compact ? ' pathway-scope-toggle--compact' : ''}`}
      role="radiogroup"
      aria-label="Show concentrations or subjects"
    >
      <button
        type="button"
        id={`${idPrefix}-conc`}
        role="radio"
        aria-checked={value === 'concentration'}
        className={value === 'concentration' ? 'is-active' : ''}
        disabled={!hasConcentrations}
        onClick={() => hasConcentrations && onChange('concentration')}
      >
        Concentrations
      </button>
      <button
        type="button"
        id={`${idPrefix}-subj`}
        role="radio"
        aria-checked={value === 'course_subject'}
        className={value === 'course_subject' ? 'is-active' : ''}
        disabled={!hasSubjects}
        onClick={() => hasSubjects && onChange('course_subject')}
      >
        Subjects
      </button>
    </div>
  );
}
